export default {
    system: 'SongMingSlideManage',
    body: {
        share: 'share',
        share_click: 'Click to share',
        ctrl_c: 'Click to copy',
        close: 'close',
        copy_success: 'Copy Success',
        copy_fail: 'Copy Failed',
        error: 'Sliced resources are corrupted',
        export_all: 'Export all',
        export_success: 'Export successful',
        export_fail: 'Export failed',
        export_filename: 'slide-share-links.xlsx',
        export_sheet: 'Slides',
        serial_no: 'No.',
        slide_name: 'Slide name',
        slide_link: 'Slide link'
    },
    setting: {
        title: 'settings',
        Current_directory: 'Current home directory',
        set: 'Set as main catalogue',
        null: 'No subcategories'
    }
}
